// extracted by mini-css-extract-plugin
module.exports = {"tagContainer":"tag_tagContainer__1rt2z","dinein":"tag_dinein__1uR82","takeout":"tag_takeout__D77Pp","wrapper":"tag_wrapper__2G7Kq","inActive":"tag_inActive__1Ja1v"};